import { css } from '@emotion/react';
import { breakpoints } from '@frontend/responsiveness';
import { theme } from '@frontend/theme';

export const fieldsetStyle = css({
  border: 'none',
  margin: 0,
  padding: 0,
  minWidth: 0,
});

export const fieldLabelStyle = css({
  marginBottom: theme.spacing(0.5),
});

export const fieldErrorStyle = css({
  color: theme.colors.text.critical,
  marginTop: theme.spacing(1),
});

export const signBoxStyle = css({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  minHeight: 120,
  padding: theme.spacing(2),
  backgroundColor: theme.colors.neutral5,
  border: `1px dashed ${theme.colors.neutral20}`,
  borderRadius: theme.borderRadius.medium,
  cursor: 'pointer',

  '&:hover, &:focus-visible': {
    borderColor: theme.colors.primary50,
  },

  '&[aria-invalid="true"]': {
    borderColor: theme.colors.critical50,
  },
});

export const signedContainerStyle = css({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: theme.spacing(0.5),
});

export const signedMetaStyle = css({
  margin: 0,
});

export const previewImageStyle = css({
  display: 'block',
  maxWidth: 150,
  maxHeight: 100,
  objectFit: 'contain',
});

export const previewTextStyle = css({
  margin: 0,
  fontSize: theme.font.size.h1,
  lineHeight: 1.3,
  color: theme.colors.neutral90,
  overflowWrap: 'anywhere',
});

export const previewStatusStyle = css({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
});

export const thumbnailImageStyle = css({
  display: 'block',
  maxWidth: 80,
  maxHeight: 40,
  objectFit: 'contain',
});

export const thumbnailTextStyle = css({
  margin: 0,
  fontSize: theme.font.size.large,
  maxWidth: 160,
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  color: theme.colors.neutral90,
});

const mobileQuery = `@media (max-width: ${breakpoints.small.max}px)`;

export const modalBodyStyle = css({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),

  [mobileQuery]: {
    '&&': { gap: theme.spacing(1.5), paddingBottom: 0 },
  },
});

export const legalNoticeStyle = css({
  [mobileQuery]: {
    '&&': {
      gap: theme.spacing(1),
      padding: theme.spacing(1, 1.5),
    },
  },
});

export const legalNoticeTextStyle = css({
  margin: 0,

  [mobileQuery]: {
    '&&': { fontSize: theme.font.size.small, lineHeight: 1.4 },
  },
});

export const tabPanelsStyle = css({
  display: 'grid',
  paddingTop: theme.spacing(2),

  [mobileQuery]: {
    paddingTop: theme.spacing(1.5),
  },
});

export const tabPanelStyle = css({
  gridArea: '1 / 1',
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(3),
  minWidth: 0,
  // Tabs.Panel marks inactive panels `hidden`; keep them in layout (invisible, unfocusable) so they still size the grid.
  '&[hidden]': { visibility: 'hidden' },
});

export const uploadDropZoneStyle = css({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: theme.spacing(1),
  flex: 1,
  width: '100%',
  minHeight: 150,

  [mobileQuery]: {
    minHeight: 120,
  },
  padding: theme.spacing(2),
  backgroundColor: theme.colors.neutral5,
  border: `1px dashed ${theme.colors.neutral20}`,
  borderRadius: theme.borderRadius.medium,

  '&:hover, &:focus-visible': {
    borderColor: theme.colors.primary50,
  },
});

export const uploadPreviewStyle = css({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: theme.spacing(1),
  flex: 1,
  padding: theme.spacing(2),
  border: `1px solid ${theme.colors.neutral20}`,
  borderRadius: theme.borderRadius.medium,
});

export const fontOptionsStyle = css({
  '& > div': {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    gap: theme.spacing(1),
  },
});

export const fontOptionTitleStyle = css({
  display: 'block',
  fontSize: theme.font.size.h2,
  lineHeight: 1.4,

  [mobileQuery]: {
    fontSize: theme.font.size.large,
  },
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
});
